const Url = "https://api-simpeg.alhasanah.sch.id"

export default Url